export const TASK_DEPARTMENTS = [
  "General",
  "Finance",
  "Sports",
  "Education",
  "Membership",
  "Public Relations",
  "Physical Resource",
] as const;

export type TaskDepartment = (typeof TASK_DEPARTMENTS)[number];

export const TASK_STATUSES = ["to-do", "progress", "cancelled", "done"] as const;
export type TaskStatus = (typeof TASK_STATUSES)[number];

export const TASK_PRIORITIES = ["normal", "high"] as const;
export type TaskPriority = (typeof TASK_PRIORITIES)[number];

export const TASK_MEMBERS = [
  "Ajward Akram",
  "Arshad Fawmy",
  "Dr. Zulfi Marikkar",
  "Faizar A Kuddoos",
  "Hasan Nawas",
  "Mohamed Fasmil",
  "Mohamed Rafi",
  "Mufees Muinudeen",
  "Mulaffar Faus",
  "Nafeel Mohamed",
  "Raashid Mansoor",
  "Rajab Khan",
  "Razeen Rahmathulla",
  "Rishad Udayar",
  "Rizmy Razik",
  "Rizwan Haleem",
  "Rizwan Mohamed",
  "Sadhir Nisthar",
  "Safwan Sufiyan",
  "Shifan Mohamed",
  "Shiran Nizar",
  "Waseem Sufiyan",
] as const;

export type TaskMember = (typeof TASK_MEMBERS)[number];

